import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";

import { CentralIntakeService } from "../../../../../services/central-intake.service";
import {
    IApplicationAndAccountQueryParam,
    IDeleteDocumentQueryParam,
    IUploadReferralDocumentQuery
} from "../../../../../resources-vue/vue-interfaces/i-get-referral";
import { ApplicationEnum } from "../../../../../enums/ApplicationEnum";

import FormSection from "../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import PatientDocuments from "../../../../CreateReferral/CreateReferralHosPal/components/PatientDocuments/PatientDocuments.vue";

export default defineComponent({
    inject: ["dialogRef"],
    components: {
        FormSection,
        PatientDocuments
    },

    data() {
        return {
            dialogReference: this.dialogRef as any,
            referral: null,
            _centralIntake: null,
            application: null as ApplicationEnum
        };
    },

    computed: {
        isPalliative() {
            return this.application === ApplicationEnum.AxxessPalliative;
        }
    },

    created() {
        this._centralIntake = Container.instance.get(CentralIntakeService);
        this.referral = this.dialogReference.data.referral;
        this.application = this.dialogReference.data.application;
    },

    methods: {
        uploadDocument(referralId: string, newDocument: IUploadReferralDocumentQuery) {
            if (this.application === ApplicationEnum.AxxessPalliative) {
                return this._centralIntake.uploadDocument(referralId, newDocument);
            } else {
                return this._centralIntake.uploadHosDocument(referralId, newDocument);
            }
        },
        deleteDocument(referralId: string, documentId: string) {
            const deleteDocumentQuery: IDeleteDocumentQueryParam = {
                referralId: referralId,
                application: this.referral.application,
                accountId: this.referral.accountId
            };

            return this._centralIntake.deleteDocument(deleteDocumentQuery, documentId);
        },

        getReferralDocuments(referralId: string) {
            const getReferralDocumentQuery: IApplicationAndAccountQueryParam = {
                application: this.referral.application,
                agencyId: this.referral.accountId
            };
            return this._centralIntake.getReferralDocuments(referralId, getReferralDocumentQuery);
        },
        closeAddDocumentsDialog() {
            this.dialogReference.close();
        }
    }
});
